export default "__VITE_ASSET__813bdfc9__"